<template>
  <div class="index">
    <!-- <Header /> -->
    <!-- banner -->
    <div class="banner_box banner_cont">
      <el-carousel>
        <el-carousel-item v-for="(item,index) in imgUrl" :key="index">
          <!-- <h3 class="small">{{ item }}</h3> -->
          <div class="banner_img">
            <img :src="item.img" alt="">
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="container_wrap">
      <!-- 要闻 -->
      <div class="home_pre clearfloat">
        <div class="home_pre_l fl">要 闻</div>
        <div class="inner">
          <el-carousel height="58px" direction="vertical" :interval="2500" indicator-position="none">
            <el-carousel-item v-for="item in newsTop" :key="item.id">
              <p class="single-line">
                <router-link class="intro-btn" :to="'/content?id='+item.id">{{ item.title }}</router-link>
              </p>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <!-- 新闻资讯 -->
      <div class="index_sec01 sec_box">
        <el-row :gutter="30">
          <el-col :span="12">
            <div class="index_sec01_left" @mouseenter="stop" @mouseleave="go">
              <transition-group name="el-fade-in-linear" duration="3000" tag="ul" ref="container">
                <li v-for="(item, index) in newsSec01Infor" :key="index" class="list-item"
                    v-show="index === currentIndex"
                    @webkitTransitionend="carouseTransition"
                >
                  <router-link class="intro-btn" :to="'/content?id='+item.id">
                    <img :src="item.img" alt="">
                    <div class="txt single-line">{{item.title}}</div>
                  </router-link>
                </li>
              </transition-group>
              <!-- 小圆点 -->
              <ol class="circles-items clearfloat">
                <li 
                  v-for="(item,index) in newsSec01Infor.length" 
                  :key="index"
                  :class="{'active':index===currentIndex}"
                  @click="change(index)">
                </li>
              </ol>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="sec_hd clearfloat">
              <div class="fl">
                <h2>集团动态</h2>
                <span>GROUP DYNAMICS</span>
              </div>
              <div class="fr">
                <router-link class="sec_hd_more" to="/news?id=8">
                  MORE +
                </router-link>
              </div>
              <div class="sec_hd_line"></div>
            </div>

            <ul class="index_sec01_wrap list_wrap">
              <li class="clearfloat" v-for="(item,index) in newsCompany" :key="index" :class="{'newslist_new':dayjs(item.updateTime).format('YYYY-MM-DD') == dayjs().format('YYYY-MM-DD')}">
                <div class="fr">{{dayjs(item.updateTime).format('YYYY-MM-DD')}}</div>
                <div class="inner single-line">
                  <router-link :to="'/content?id=' + item.id">
                    {{item.title}}
                  </router-link>
                </div>
              </li>
            </ul>

          </el-col>
        </el-row>

      </div>

      <div class="index_sec02 sec_box">
        <el-row :gutter="30">
          
          <el-col :span="12">
            <div class="sec_hd clearfloat">
              <div class="fl">
                <h2>公司动态</h2>
                <span>COMPANY DYNAMICS</span>
              </div>
              <div class="fr">
                <router-link class="sec_hd_more" to="/news/bases">
                  MORE +
                </router-link>
              </div>
              <div class="sec_hd_line"></div>
            </div>

            <ul class="index_sec01_wrap list_wrap">
              <li class="clearfloat" v-for="(item,index) in newsBases" :key="index" :class="{'newslist_new':dayjs(item.updateTime).format('YYYY-MM-DD') == dayjs().format('YYYY-MM-DD')}">
                <div class="fr">{{dayjs(item.updateTime).format('YYYY-MM-DD')}}</div>
                <div class="inner single-line">
                  <router-link :to="'/content?id=' + item.id">
                    {{item.title}}
                  </router-link>
                </div>
              </li>
            </ul>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10" class="index_sec02_left">
              <el-col :span="8">
                <div class="xx_grop" @click="visibleDsz = true">
                  <div class="sec02_left_pic">
                    <img src="../assets/img/index/img_index_link01.png" alt="">
                  </div>
                  <div class="inner">董事长信箱</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="xx_grop" @click="visibleLz = true">
                  <div class="sec02_left_pic">
                    <img src="../assets/img/index/img_index_link02.png" alt="">
                  </div>
                  <div class="inner">廉政信箱</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="xx_grop" @click="visibleZg = true">
                  <div class="sec02_left_pic">
                    <img src="../assets/img/index/img_index_link03.png" alt="">
                  </div>
                  <div class="inner">职工意见箱</div>
                </div>
              </el-col>
              <el-col :span="8">
                <router-link class="xx_grop" to="/about">
                  <div class="sec02_left_pic">
                    <img src="../assets/img/index/img_index_link04.png" alt="">
                  </div>
                  <div class="inner">关于我们</div>
                </router-link>
              </el-col>
              <el-col :span="8">
                <router-link class="xx_grop" to="/about/invite">
                  <div class="sec02_left_pic">
                    <img src="../assets/img/index/img_index_link05.png" alt="">
                  </div>
                  <div class="inner">招贤纳士</div>
                </router-link>
              </el-col>
              <el-col :span="8">
                <!-- <router-link class="xx_grop" to="http://125.75.0.175:8951/seeyon/index.jsp">
                  <div class="sec02_left_pic">
                    <img src="../assets/img/index/img_index_link06.png" alt="">
                  </div>
                  <div class="inner">办公OA</div>
                </router-link> -->
                <a class="xx_grop" href="http://125.75.0.175:8951/seeyon/index.jsp"  target="_blank">
                  <div class="sec02_left_pic">
                    <img src="../assets/img/index/img_index_link06.png" alt="">
                  </div>
                  <div class="inner">办公OA</div>
                </a>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>

      <div class="index_sec03 sec_box">
        <div class="sec_hd clearfloat">
          <div class="fl">
            <h2>项目展示</h2>
            <span>ITEM SHOW</span>
          </div>
          <div class="fr">
            <router-link class="sec_hd_more" to="/project">
              MORE +
            </router-link>
          </div>
          <div class="sec_hd_line"></div>
        </div>
        <el-row :gutter="30" id="mapBox">
          <div class="index_pro" style="height: 800px"></div>
        </el-row>
      </div>

      <div class="index_sec04 sec_box">
        <img src="../assets/img/index/middle.jpg" alt="">
      </div>

      <div class="index_sec05 sec_box">
        <el-row :gutter="30">
          <el-col :span="12">
            <div class="sec_hd clearfloat">
              <div class="fl">
                <h2>党的建设</h2>
                <span>PARTY BUILDING</span>
              </div>
              <div class="fr">
                <router-link class="sec_hd_more" to="/search?id=13">
                  MORE +
                </router-link>
              </div>
              <div class="sec_hd_line"></div>
            </div>
            <ul class="index_sec01_wrap list_wrap">
              <li class="clearfloat" v-for="(item,index) in newsParty" :key="index" :class="{'newslist_new':dayjs(item.updateTime).format('YYYY-MM-DD') == dayjs().format('YYYY-MM-DD')}">
                <div class="fr">{{dayjs(item.updateTime).format('YYYY-MM-DD')}}</div>
                <div class="inner single-line">
                  <router-link :to="'/content?id=' + item.id">
                    {{item.title}}
                  </router-link>
                </div>
              </li>
            </ul>
          </el-col>
          <el-col :span="12">
            <div class="sec_hd clearfloat">
              <div class="fl">
                <h2>基层动态</h2>
                <span>BASES DYNAMICS</span>
                <!-- <h2>公示公告</h2>
                <span>PUBLIC NOTICE</span> -->
              </div>
              <div class="fr">
                <router-link class="sec_hd_more" to="/news/notice">
                  MORE +
                </router-link>
              </div>
              <div class="sec_hd_line"></div>
            </div>
            <ul class="index_sec01_wrap list_wrap">
              <li class="clearfloat" v-for="(item,index) in newsNotic" :key="index" :class="{'newslist_new':dayjs(item.updateTime).format('YYYY-MM-DD') == dayjs().format('YYYY-MM-DD')}">
                <div class="fr">{{dayjs(item.updateTime).format('YYYY-MM-DD')}}</div>
                <div class="inner single-line">
                  <router-link :to="'/content?id=' + item.id">
                    {{item.title}}
                  </router-link>
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>

      <div class="index_sec07 sec_box">
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item,index) in toppicImg" :key="index">
            <router-link :to="'/search?id=' + item.id"><img :src="item.img" alt=""></router-link>
          </el-col>
        </el-row>
      </div>

      <div class="index_sec07 sec_box">
        <div class="sec_hd clearfloat">
          <div class="fl">
            <h2>友情链接</h2>
            <span>FRIENDLY LINK</span>
          </div>
          <div class="fr">
          </div>
          <div class="sec_hd_line"></div>
        </div>
        <div class="link_wrap">
          <div class="link_wrap_grap clearfloat">
            <div class="fl name">行业网站:</div>
            <div class="inner">
              <a href="http://gzw.gansu.gov.cn/" target="_blank">省政府国资委</a>
              <a href="http://www.gsgczx.cn/" target="_blank">甘肃工程咨询集团股份有限公司</a>
              <a href="https://jtys.gansu.gov.cn/" target="_blank">甘肃省交通运输厅</a>
              <a href="http://zjt.gansu.gov.cn/" target="_blank">甘肃省住房和城乡建设厅</a>
              <a href="http://www.gsjtzj.com/" target="_blank">甘肃省交通工程质量安全监督管理局</a>
            </div>
            <div class="fl name">其它网站:</div>
            <div class="inner">
              <a href="http://www.cpta.com.cn/" target="_blank">中国人事考试网</a>
              <a href="http://www.jtzyzg.org.cn/LTPU/LEAP/home/html/index.html" target="_blank">交通职业资格网</a>
              <a href="https://glxy.mot.gov.cn/" target="_blank">全国公路建设市场信用信息管理系统</a>
            </div>
          </div>
        </div>
      </div>

      <div class="index_sec07 sec_box report_box">
        <!-- <div class="sec_hd clearfloat">
          <div class="fl">
            <h2 style="color: #ff0000;">举报方式</h2>
            <span style="color: #ff0000;">REPORT WAY</span>
          </div>
          <div class="fr">
          </div>
          <div class="sec_hd_line"></div>
        </div> -->
        <div class="link_wrap">
          <el-row :gutter="30">
            <el-col :span="12">
              <div class="report_grop">
                <div class="report_tit">甘肃工程咨询集团纪委举报方式</div>
                <div class="report_inner">
                  <p>
                    举报电话：0931-6956633
                  </p>
                  <p>
                    举报邮箱：gsgczxjtjw@163.com
                  </p>
                  <p>
                    举报地址：兰州市城关区平凉路284号4楼403室
                  </p>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="report_grop">
                <div class="report_tit">省交通监理公司纪委举报方式</div>
                <div class="report_inner">
                  <p>
                    举报电话：0931-8616075-8050/8051
                  </p>
                  <p>
                    举报邮箱：gsjtjlgsjw@163.com
                  </p>
                  <p>
                    举报地址：甘肃省兰州市和平新村127号元富大厦8楼805
                  </p>
                </div>
              </div>
              
            </el-col>
          </el-row>
          <!-- <div class="link_wrap_grap clearfloat">
            <div class="fl name">甘肃工程咨询集团纪检:</div>
            <div class="inner">
              <a href="http://gzw.gansu.gov.cn/" target="_blank">省政府国资委</a>
              <a href="http://www.gsgczx.cn/" target="_blank">甘肃工程咨询集团股份有限公司</a>
              <a href="https://jtys.gansu.gov.cn/" target="_blank">甘肃省交通运输厅</a>
              <a href="http://zjt.gansu.gov.cn/" target="_blank">甘肃省住房和城乡建设厅</a>
              <a href="http://www.gsjtzj.com/" target="_blank">甘肃省交通工程质量安全监督管理局</a>
            </div>
            <div class="fl name">其它网站:</div>
            <div class="inner">
              <a href="http://www.cpta.com.cn/" target="_blank">中国人事考试网</a>
              <a href="http://www.jtzyzg.org.cn/LTPU/LEAP/home/html/index.html" target="_blank">交通职业资格网</a>
              <a href="https://glxy.mot.gov.cn/" target="_blank">全国公路建设市场信用信息管理系统</a>
            </div>
          </div> -->
        </div>
      </div>
      
    </div>



    <!-- <Footer /> -->

    <!-- 董事长信箱 -->
    <el-dialog
      title="董事长信箱"
      :visible.sync="visibleDsz"
      width="660px"
      center>
      <div class="text_xx_box">
        <el-input
          type="textarea"
          :rows="10"
          placeholder="请输入留言内容"
          v-model="textareaDsz">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDsz = false">取 消</el-button>
        <el-button type="primary" @click="sendDsz">提交</el-button>
      </span>
    </el-dialog>

    <!-- 廉政信箱 -->
    <el-dialog
      title="廉政信箱"
      :visible.sync="visibleLz"
      width="660px"
      center>
      <div class="text_xx_box">
        <el-input
          type="textarea"
          :rows="10"
          placeholder="请输入留言内容"
          v-model="textareaLz">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleLz = false">取 消</el-button>
        <el-button type="primary" @click="sendLz">提交</el-button>
      </span>
    </el-dialog>

    <!-- 职工意见箱 -->
    <el-dialog
      title="职工意见箱"
      :visible.sync="visibleZg"
      width="660px"
      center>
      <div class="text_xx_box">
        <el-input
          type="textarea"
          :rows="10"
          placeholder="请输入留言内容"
          v-model="textareaZg">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleZg = false">取 消</el-button>
        <el-button type="primary" @click="sendZg">提交</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
// import Header from "@/components/header.vue";
// import Footer from "@/components/footer.vue";
// import SeamlessScroll from "@/components/seamlessScroll.vue";
// import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  name: "index",
  components: {
    // Header,
    // Footer,
    // SeamlessScroll
    // vueSeamlessScroll
  },
  data(){
    return {
      imgUrl: [
        // require('../assets/img/1.jpg'),
        // require('../assets/img/2.jpg'),
        // require('../assets/img/1.jpg'),
        // require('../assets/img/2.jpg')
      ],
      newsTop: [
      
      ],
      newsSec01Infor: [
        // {
        //   img: require('../assets/img/index/about-pic03.jpg'),
        //   title: '新一代信息服务平台上线01',
        //   id: ''
        // },
        // {
        //   img: require('../assets/img/index/about-pic04.jpg'),
        //   title: '新一代信息服务平台上线02',
        //   id: ''
        // },
        // {
        //   img: require('../assets/img/index/about-pic05.jpg'),
        //   title: '新一代信息服务平台上线03',
        //   id: ''
        // }
      ],
      // 当前索引
      currentIndex: 0,
      // 定时器
      timer: '',
      // 小圆点开关
      begin: '',
      itemList: [
        {
          id: '1',
          title: '彭大高速公路钢筋加工厂01',
          img: require('../assets/img/index/index_item_img01.jpg')
        }
      ],
      classOption: {
        limitMoveNum: 2,
        direction: 2,
      },
      icon: require('../assets/logo_01.png'),
      toppicImg: [],
      visibleDsz: false,
      visibleLz: false,
      visibleZg: false,
      textareaDsz: '',
      textareaLz: '',
      textareaZg: '',
      newsCompany: [],
      newsBases: [],
      newsParty : [],
      newsNotic: [],
      positionList: []
    }
  },
  created:function(){
    var _this = this
    _this.getBannerData();
    _this.getToppicData();
    _this.getNewsCompany();
    _this.getNewsBases();
    _this.getNewsParty();
    _this.getNewsNotic();
    _this.getNewsTop();
    _this.getFouce();
    _this.getProjectInfo();
  },
  mounted: function () {
    this.$nextTick(() => {
      if (this.begin) {
        return;
      }
      this.begin = true;
      this.timer = setInterval(() => {
        this.autoPlay()
      }, 3000)
    });
    var _this = this;
    setTimeout(function(){
      _this.createMap();
    },1000)
  },
  methods: {
    // banner
    async getBannerData(){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/getBanner');
      if(data.code == 200){
        _this.imgUrl = data.data
      }
    },
    // 专题
    async getToppicData(){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/getTopic');
      if(data.code == 200){
        _this.toppicImg = data.data
      }
    },
    // 公司动态
    async getNewsCompany(){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/getNewsList',{page: 1, classification: 8});
      if(data.code == 200){
        if(data.data.list.length < 6){
          data.data.list.forEach(line => {
            _this.newsCompany.push(line)
          })
        }else{
          for(var i = 0; i<6; i++){
            _this.newsCompany.push(data.data.list[i])
          }
        }
      }
    },
    // 基层动态
    async getNewsBases(){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/getNewsList',{page: 1, classification: 9});
      if(data.code == 200){
        if(data.data.list.length < 6){
          data.data.list.forEach(line => {
            _this.newsBases.push(line)
          })
        }else{
          for(var i = 0; i<6; i++){
            _this.newsBases.push(data.data.list[i])
          }
        }
      }
    },
    // 党的建设
    async getNewsParty(){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/getNewsList',{page: 1, classification: 13});
      if(data.code == 200){
        if(data.data.list.length < 6){
          data.data.list.forEach(line => {
            _this.newsParty.push(line)
          })
        }else{
          for(var i = 0; i<6; i++){
            _this.newsParty.push(data.data.list[i])
          }
        }
      }
    },
    // 公示公告
    async getNewsNotic(){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/getNewsList',{page: 1, classification: 10});
      if(data.code == 200){
        if(data.data.list.length < 6){
          data.data.list.forEach(line => {
            _this.newsNotic.push(line)
          })
        }else{
          for(var i = 0; i<6; i++){
            _this.newsNotic.push(data.data.list[i])
          }
        }
      }
    },
    // 要闻
    async getNewsTop(){
      var _this = this
      // var { data } = await _this.$http.post(_this.apiUrl + '/getNewsList',{page: 1, classification: 8});
      var { data } = await _this.$http.post(_this.apiUrl + '/getImportNews');
      if(data.code == 200){
        if(data.data.length < 5){
          data.data.forEach(line => {
            _this.newsTop.push(line)
          })
        }else{
          for(var i = 0; i<5; i++){
            _this.newsTop.push(data.data[i])
          }
        }
      }
    },
    // 焦点图
    async getFouce(){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/getImgNews');
      if(data.code == 200){
        if(data.data.length && data.data.length != 0 && data.data[0].img){
          if(data.data.length > 8){
            _this.newsSec01Infor = data.data.slice(0,8)
          }else{
            _this.newsSec01Infor = data.data
          }
        }
        
      }
    },
    // 项目信息
    async getProjectInfo(){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/project/getProjectInfoDetailForMap');
      if(data.code == 200){
        _this.positionList = data.data  
      }
    },
    go() {
      this.timer = setInterval(() => {
        this.autoPlay()
      }, 4000)
    },
    stop() {
      clearInterval(this.timer);
      this.timer = null
    },
    change(index) {
      this.currentIndex = index
    },
    autoPlay() {
      this.currentIndex++;
      if (this.currentIndex > this.newsSec01Infor.length - 1) {
        this.currentIndex = 0
      }
    },
    carouseTransition() {
      this.begin = false;
    },
    createMap() {
      var _this = this;
      var map = new window.AMap.Map("mapBox", {
        mapStyle: 'amap://styles/whitesmoke',
        resizeEnable: true,
        // zoom: 11,
        // center: [116.397428, 39.90923]
      });

      _this.createMapPosition(map);

      var polygons = [];
      var district = new window.AMap.DistrictSearch({
        subdistrict: 0, //获取边界不需要返回下级行政区
        extensions: "all", //返回行政区边界坐标组等具体信息
        level: "district", //查询行政级别为
      });
      //行政区查询
      district.setLevel("district");
      district.search("甘肃",
        function (status, result) {
          map.remove(polygons); //清除上次结果
          polygons = [];
          var bounds = result.districtList[0].boundaries;
          if (bounds) {
            for (var i = 0, l = bounds.length; i < l; i++) {
              //生成行政区划polygon
              var polygon = new window.AMap.Polygon({
                strokeWeight: 1,
                path: bounds[i],
                fillOpacity: 0.4,
                fillColor: "#80d8ff",
                strokeColor: "#0091ea",
              });
              polygons.push(polygon);
            }
          }
          map.add(polygons);
          map.setFitView(polygons); //视口自适应
        }
      );

    },
    createMapPosition(map) {
      var _this = this;
      var infoWindow = new window.AMap.InfoWindow({offset: new window.AMap.Pixel(0, -30)});
      var positionList = _this.positionList;
      for(var i = 0; i < positionList.length; i++){
        var position=[positionList[i].longitude, positionList[i].latitude];
        var marker = new window.AMap.Marker({
            map: map,
            position: position
        });
        var txt = '<div class="map_wrap" style="padding-left: 6px;">'+
                    '<div class="map_tit" style="font-size: 18px; text-align: center; line-height: 40px;">' + positionList[i].name + '</div>'+
                    '<div class="map_img" style="width: 340px;"><a href="/projectDetail?id=' + positionList[i].id + '" title="点击查看详情"><img src="'+ positionList[i].img +'" style="width: 100%;"></a></div>'+
                  '</div>'
        // marker.setIcon(_this.icon)
        // marker.content = '我是' + positionList[i].info;
        marker.content = txt;
        marker.on('click', function(e){
          infoWindow.setContent(e.target.content);
          infoWindow.open(map, e.target.getPosition());
        });
        // marker.emit('click', {target: marker});
      }
    },
    // 董事长信箱
    sendDsz() {
      var _this = this

      if(_this.textareaDsz.match(/^\s*$/)){
        this.$message({
          message: '请输入留言了内容',
          type: 'warning'
        });
      }else{
        this.$confirm('确认是否提交？')
        .then(() => {
          _this.sendTxt(1, _this.textareaDsz)
          _this.textareaDsz = ''
          _this.visibleDsz = false
        })
        .catch(() => {});
      }
    },
    // 廉政信箱
    sendLz(){
      var _this = this
      if(_this.textareaLz.match(/^\s*$/)){
        this.$message({
          message: '请输入留言了内容',
          type: 'warning'
        });
      }else{
        this.$confirm('确认是否提交？')
        .then(() => {
          _this.sendTxt(2, _this.textareaLz)
          _this.textareaLz = ''
          _this.visibleLz = false
        })
        .catch(() => {});
      }
    },
    // 职工信箱
    sendZg(){
      var _this = this
      if(_this.textareaZg.match(/^\s*$/)){
        this.$message({
          message: '请输入留言了内容',
          type: 'warning'
        });
      }else{
        this.$confirm('确认是否提交？')
        .then(() => {
          _this.sendTxt(3, _this.textareaZg)
          _this.textareaZg = ''
          _this.visibleZg = false
        })
        .catch(() => {});
      }
    },
    async sendTxt(type,text){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/sendMail',{type: type, text: text});
      if(data.code == 200){
        this.$message({
          message: '提交成功！',
          type: 'success'
        });
      }else{
        this.$message({
          message: '提交失败，请稍后重试！',
          type: 'warning'
        });
      }
    },

  },
}
</script>

<style scoped>
  .home_pre {
    padding: 8px 0;
    font-size: 18px;
    border: 1px solid #e3e8ef;
    line-height: 80px;
    box-shadow: 0 0 12px #d9edff;
    margin-bottom: 35px;
  }
  .home_pre_l {
    width: 80px;
    text-align: center;
    color: #1970b9;
    font-weight: 600;
    font-size: 22px;
    border-right: 1px solid #b1c7e0;
  }
  .home_pre .inner {
    margin-left: 80px;
    padding: 0 20px;
    font-size: 20px;
  }
  .home_pre a:hover {
    color: #ee1d1d;
  }
  /* 小banner */
  .index_sec01_left {
    position: relative;
    height: 400px;
  }
  .index_sec01_left ul {
    height: 100%;
  }
  .index_sec01_left ul li {
    width: 100%;
    height: 100%;
    position: absolute;
    overflow: hidden;
  }
  .index_sec01_left ul li img {
    width: 100%;
    height: 100%;
  }
  .index_sec01_left ul li .txt {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    height: 52px;
    line-height: 52px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 0 20px;
    box-sizing: border-box;
  }
  .index_sec01_left ol {
    position: absolute;
    right: 14px;
    bottom: 21px;
    z-index: 3;
  }
  .index_sec01_left ol li {
    float: left;
    width: 11px;
    height: 11px;
    border-radius: 100%;
    background-color: #fff;
    margin: 0 5px;
    cursor: pointer;
  }
  .index_sec01_left ol li.active {
    background-color: #1970b9;
  }
</style>

<style>
  .amap-icon img {
    max-width: 40px !important;
    /* max-height: 17.5px !important; */
  }
</style>